module.exports = __webpack_public_path__ + "static/img/main_back.eada2e89.png";